import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrivacySecurity = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.65625 3.375V5H7.71875V3.375C7.71875 2.25781 6.80469 1.34375 5.6875 1.34375C4.54492 1.34375 3.65625 2.25781 3.65625 3.375ZM2.4375 5V3.375C2.4375 1.59766 3.88477 0.125 5.6875 0.125C7.46484 0.125 8.9375 1.59766 8.9375 3.375V5H9.75C10.6387 5 11.375 5.73633 11.375 6.625V11.5C11.375 12.4141 10.6387 13.125 9.75 13.125H1.625C0.710938 13.125 0 12.4141 0 11.5V6.625C0 5.73633 0.710938 5 1.625 5H2.4375ZM1.21875 6.625V11.5C1.21875 11.7285 1.39648 11.9062 1.625 11.9062H9.75C9.95312 11.9062 10.1562 11.7285 10.1562 11.5V6.625C10.1562 6.42188 9.95312 6.21875 9.75 6.21875H1.625C1.39648 6.21875 1.21875 6.42188 1.21875 6.625Z",
		fill: "#B6B6B6"
	})
});
export { SvgPrivacySecurity as ReactComponent };
